import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import type { Language } from 'appShell/_types/src/i18n/config';
import {
  API_ENDPOINT,
  useClientApiV1UserOnboardingsAnswersQuery,
} from '../../resources/@types/uccSchema';

interface UseClientV1UserOnboardingsAnswersQuery {
  lang?: Language;
  options?: Parameters<typeof useClientApiV1UserOnboardingsAnswersQuery>[0]['options'];
}

export function useUserOnboardingsAnswersQuery({
  lang = 'ko',
  options,
}: UseClientV1UserOnboardingsAnswersQuery) {
  return useClientApiV1UserOnboardingsAnswersQuery({
    queryKey: getUserOnboardingsAnswersQueryKey(lang),
    url: API_ENDPOINT.CLIENT_V1_USER_ONBOARDINGS_ANSWERS,
    options,
  });
}

export const getUserOnboardingsAnswersQueryKey = (lang: Language): QueryKeyReturnType => [
  API_ENDPOINT.CLIENT_V1_USER_ONBOARDINGS_ANSWERS,
  lang,
];
